import PromoTextSection from './Component';

export default PromoTextSection;